import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';

import {
  Alert,
  AlertContext,
  getSVGViewBox
} from '../assets';

@Component({
  selector: 'kyc-icon-alert',
  template: Alert.svg,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertComponent implements SVG2TSDynamic, OnInit {
  public static UUID = 0;
  public baseUrl: string;
  @Input() public height: number | string = Alert.height;
  @Input() public viewBox: string = getSVGViewBox(Alert.viewBox);
  @Input() public width: number | string = Alert.width;
  @Input()
  public set context(ctx: AlertContext) {
    this.updateContext(ctx);
  }
  public get context() {
    return this._context;
  }

  private _context: AlertContext = Alert.contextDefaults;

  constructor(private _ref: ChangeDetectorRef) {}


  public getURLBase(value: string) {
    return `url('${this.getXlinkBase(value)}')`;
  }

  public getXlinkBase(value: string) {
    return `${this.baseUrl}${value}`;
  }

  public ngOnInit() {
    this.baseUrl = window.location.href.replace(window.location.hash, '');
    this.context.uuid = AlertComponent.UUID++;
  }

  public updateContext(ctx: any) {
    this._context = Object.assign({}, this._context ? this._context : Alert.contextDefaults, ctx);
    this._ref.markForCheck();
  }
}
